<template>
    <div class="index-container">
        <Logo />
        <Sidebar />
        <div class="index-swiper" v-if="bannerList.length > 0">
            <van-swipe class="my-swipe" :autoplay="3000">
                <van-swipe-item v-for="(item, index) in bannerList" :key="index">
                    <a :href='item.jump_link'>
                        <img :src="item.banner_url" class="swiper-img"/>
                    </a>
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="index-main bg-color">
            <div class="index-introduce">
                <div class="introduce-top project">
                    <div class="introduce-top-img">
                        <img src="../assets/images/png_home_title.png" >
                    </div>
                    <div class="introduce-top-text">马兰花中国创业培训项目介绍</div>
                    <div class="introduce-top-link" @click="projectIntro">详情介绍</div>
                </div>
                <div class="introduce-center" @click="playVideo(project)">
                    <div class="introduce-center-img">
                        <img :src="project.cover_url" >
                    </div>
                    <div class="introduce-center-play">
                        <img src="../assets/images/btn_start.png" >
                    </div>
                </div>
                <div class="introduce-bottom">
                    <div class="introduce-bottom-text">
                        <img src="../assets/images/png_title_video.png">
                    </div>
                </div>
            </div>
            <div class="index-introduce">
                <div class="introduce-center" @click="ImagePreview('showroom')">
                    <div class="introduce-center-img">
                        <img src="../assets/images/png_3d.png" >
                        <!-- <img src="../assets/images/png_bg.png" > -->
                    </div>
                    <!-- <div class="introduce-center-list">
                        <div class="center-list-item" v-for="(item,index) in showRoom" :key="index">
                            <img :src="item" >
                        </div>
                    </div> -->
                </div>
                <div class="introduce-bottom">
                    <div class="introduce-bottom-text">
                        <img src="../assets/images/png_title_3d.png">
                    </div>
                </div>
            </div>
        </div>
        <div class="index-main">
            <div class="index-introduce">
                <div class="introduce-top plan">
                    <div class="introduce-top-img">
                        <img src="../assets/images/png_home_title.png" >
                    </div>
                    <div class="introduce-top-text">“马兰花计划”介绍</div>
                    <div class="introduce-top-link" @click="planIntro">详情介绍</div>
                </div>
                <div class="introduce-center" @click="playVideo(plan)">
                    <div class="introduce-center-img">
                        <img :src="plan.cover_url" >
                    </div>
                    <div class="introduce-center-play">
                        <img src="../assets/images/btn_start.png" >
                    </div>
                </div>
            </div>
            <div class="index-introduce">
                <div class="introduce-top megagame">
                    <div class="introduce-top-img">
                        <img src="../assets/images/png_home_title.png" >
                    </div>
                    <div class="introduce-top-text">创业培训讲师大赛介绍</div>
                    <div class="introduce-top-link" @click="introduceIntro">详情介绍</div>
                </div>
                <div class="introduce-center" @click="playVideo(megagame)">
                    <div class="introduce-center-img">
                        <img :src="megagame.cover_url" >
                    </div>
                    <div class="introduce-center-play">
                        <img src="../assets/images/btn_start.png" >
                    </div>
                </div>
            </div>
        </div>
        <van-overlay :show="isShow">
            <div class="video-close" @click="closeVideo">
                <img src="../assets/images/close.ss.png">
            </div>
            <div class="video-box">
                <video oncontextmenu="return false" width="100%" height="100%" ref="videoPlayer" :src="videoPreview.video_url" :poster="videoPreview.cover_url" controls controlslist="nodownload" disablePictureInPicture></video>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import { getBanner, getVideo } from "../api/index"
import Logo from "../components/Logo"
import Sidebar from "../components/Sidebar"

import { ImagePreview } from 'vant'
export default {
    name: 'index',
    data() {
        return {
            project: '',
            plan: '',
            megagame: '',
            bannerList: [],
            showRoom: [
                require("@/assets/images/1.jpg"),
                require("@/assets/images/2.jpg"),
                require("@/assets/images/3.jpg"),
                require("@/assets/images/4.jpg"),
                require("@/assets/images/5.jpg"),
                require("@/assets/images/6.jpg"),
                require("@/assets/images/7.jpg"),
                require("@/assets/images/8.jpg"),
                require("@/assets/images/9.jpg"),
                require("@/assets/images/10.jpg")
            ],
            isShow: false,
            videoPreview: {}
        }
    },
    components: {
        Logo,
        Sidebar
    },
    created() {
        this.getBanner()
        this.getVideo()
    },
    methods: {
        getBanner() {
            getBanner().then(res=>{
                if(res.code == 200){
                    let bannerData = res.data.list
                    let rebels = bannerData
                    .filter(pilot => pilot.suit === 1)
                    // .map(jedi => jedi.banner_url)
                    this.bannerList = rebels
                }
            }).catch({})
        },
        getVideo(){
            getVideo().then(res=>{
                if(res.code == 200){
                    let videoData = res.data.list
                    this.project = videoData.filter(pilot => pilot.type === 1)[0]
                    this.plan = videoData.filter(pilot => pilot.type === 2)[0]
                    this.megagame = videoData.filter(pilot => pilot.type === 3)[0]
                }
            }).catch({})
        },
        playVideo(row) {
            this.videoPreview = row
            this.isShow = true
        },
        closeVideo() {
            this.isShow = false
            this.$refs.videoPlayer.pause();
        },
        ImagePreview(type,index) {
            if(type == 'banner') ImagePreview({images:this.bannerList,startPosition: index})
            if(type == 'showroom') ImagePreview(this.showRoom)
        },
        projectIntro() {
            this.$router.push({ name: "projectIntro" })
        },
        planIntro() {
            this.$router.push({ name: "planIntro" })
        },
        introduceIntro() {
            this.$router.push({ name: "introduce" })
        }
    }
}
</script>
<style lang="scss" scoped>
.index-container{
    .van-overlay{
        background-color: rgba(0,0,0,1);
    }
}
.index-swiper{
    ::v-deep .van-swipe__indicator{
        width: 40px;
        height: 6px;
        border-radius: 3px;
        background-color: #fff;
        opacity: 1;
        &.van-swipe__indicator--active{
            background-color: #2F54EB;
        }
    }
    .swiper-img{
        display: block;
        width: 100%;
        height: 290px;
    }
}
.index-main{
    padding: 48px 24px;
    &.bg-color{
        background-color: #F4F6FD;
    }
}
.index-introduce{
    margin-bottom: 40px;
    &:last-child{
        margin-bottom: 0;
    }
    .introduce-top{
        position: relative;
        display: flex;
        // height: 112px;
        align-items: center;
        padding: 30px 24px 30px 16px;
        box-shadow: 0px 8px 12px -2px rgba(0, 0, 0, 0.16);
        .introduce-top-img{
            position: absolute;
            width: 101px;
            height: 105px;
            left: 0;
            bottom: 0;
            img{
                display: block;
                width: 100%;
                height: 100%;
            }
        }
        .introduce-top-text{
            position: relative;
            flex: 1;
            font-size: 36px;
            font-family: "YouSheBiaoTiHei";
            color: #FFFFFF;
            line-height: 46px;
        }
        .introduce-top-link{
            // width: 144px;
            line-height: 48px;
            border-radius: 4px;
            border: 1px solid #FFFFFF;
            font-size: 28px;
            color: #fff;
            box-sizing: border-box;
            text-align: center;
            padding: 0 15px;
        }
        &.project{
            background: linear-gradient(90deg, #5494FF 0%, #8AA0FE 100%);
            .introduce-top-text{
                text-shadow: 0px 2px 4px #3567D3;
            }
        }
        &.plan{
            background: linear-gradient(90deg, #2E98FF 0%, #74C8FF 100%);
            .introduce-top-text{
                text-shadow:  0px 5px 10px rgba(19, 115, 204, 0.71);
            }
        }
        &.megagame{
            background: linear-gradient(90deg, #EDA200 0%, #EEBC10 100%);
            .introduce-top-text{
                text-shadow: 0px 5px 10px #CC9102;
            }
        }
    }
    .introduce-center{
        position: relative;
        .introduce-center-img{
            img{
                display: block;
                width: 100%;
                height: 395px;
            }
        }
        .introduce-center-list{
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            display: flex;
            align-items: center;
            .center-list-item{
                &:nth-child(1){
                    img{
                        display: block;
                        width: 131px;
                        height: 210px;
                        -webkit-transform-style: preserve-3d;
                        transform-style: preserve-3d;
                        -webkit-transform: rotateY(90deg);
                        transform: rotateY(90deg);
                    }
                }
                &:nth-child(2){
                    img{
                        height: 140px;
                    }
                }
                &:nth-child(3){
                    img{
                        height: 95px;
                    }
                }
                &:nth-child(4){
                    img{
                        height: 66px;
                    }
                }
                &:nth-child(5){
                    img{
                        height: 66px;
                    }
                }
                &:nth-child(6){
                    img{
                        height: 66px;
                    }
                }
                &:nth-child(7){
                    img{
                        height: 66px;
                    }
                }
                &:nth-child(8){
                    img{
                        height: 95px;
                    }
                }
                &:nth-child(9){
                    img{
                        height: 140px;
                    }
                }
                &:nth-child(10){
                    img{
                        height: 210px;
                    }
                }
            }
        }
        .introduce-center-play{
            position: absolute;
            width: 122px;
            height: 122px;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            img{
                display: block;
                width: 100%;
                height: 100%;
            }
        }
    }
    .introduce-bottom{
        background-color: #fff;
        height: 80px;
        display: flex;
        align-items: center;
        .introduce-bottom-text{
            flex: 1;
            text-align: center;
            img{
                height: 26px;
            }
        }
    }
}
.video-close{
    position: absolute;
    width: 84px;
    height: 84px;
    right: 0;
    top: 0;
    margin: auto;
    img{
        display: block;
        width: 48px;
        height: 48px;
        margin-top: 18px;
        margin-left: 18px;
    }
}
.video-box{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 84px;
    margin: auto;
}
</style>